import
  React
from 'react';

import {
  Colors,
  FontSizes,
  ErrorToast,
  Logger,
  Messages,
  PopupFooter,
  PopupActionContainer,
  PopupActionButtonContainer,
  generateYearArray,
  isValidProviderResult,
} from 'common';

import {
  Button,
  Checkbox,
  Loader,
  Select,
  Popup,
  Text,
  TextInput,
} from 'common/components';

import {
  Container,
  ItemRow,
  Item,
  PopupContent,
  ActionContainer,
  ActionButtonContainer,
  LoadingContainer,
  DeleteContainer,
} from './accountComponentsStyled';

import {
  LookupProvider,
  UserProvider,
} from 'providers';

export class ProfessionalExperienceForm extends React.Component {

  state = {
    employmentTypes: [],
    yearList: [],
    monthList: [],
    roleError: '',
    companyError: '',
    employmentTypeError: '',
    startMonthError: '',
    endMonthError: '',
    startYearError: '',
    endYearError: '',
    descriptionError: '',
    isCurrentlyWorkingInThisRole: !!(this.props.data && this.props.data.isCurrentlyWorkingInThisRole),
    isLoading: false,
    showDeletePopup: false,
  };

  data = this.props.data || {};

  onSaveChangesClick = () => {

    const errors = this.validate();

    if (Object.keys(errors).length) {
      return;
    }

    this.saveChanges()
      .catch(e => {

        ErrorToast.show();
        Logger.error(e);
      });
  };

  onIsCurrentlyWorkingInThisRoleClick = checked => {

    this.data.shouldSave = true;

    this.data.isCurrentlyWorkingInThisRole = checked;

    this.props.onChange && this.props.onChange();

    this.setState({
      isCurrentlyWorkingInThisRole: checked,
    });
  };

  onRoleChange = val => {

    this.data.shouldSave = true;

    this.data.role = val;

    this.props.onChange && this.props.onChange();

    if (this.state.roleError) {

      this.setState({
        roleError: '',
      });
    }
  };

  onCompanyChange = val => {

    this.data.shouldSave = true;

    this.data.company = val;

    this.props.onChange && this.props.onChange();

    if (this.state.companyError) {

      this.setState({
        companyError: '',
      });
    }
  };

  onEmploymentTypeChange = val => {

    this.data.shouldSave = true;

    this.data.employmentType = val;

    this.props.onChange && this.props.onChange();

    if (this.state.employmentTypeError) {

      this.setState({
        employmentTypeError: '',
      });
    }
  };

  onStartYearChange = val => {

    this.data.shouldSave = true;

    this.data.startYear = val;

    this.props.onChange && this.props.onChange();

    if (this.state.startYearError) {

      this.setState({
        startYearError: '',
      });
    }
  };

  onEndYearChange = val => {

    this.data.shouldSave = true;

    this.data.endYear = val;

    this.props.onChange && this.props.onChange();

    if (this.state.endYearError) {

      this.setState({
        endYearError: '',
      });
    }
  };

  onStartMonthChange = val => {

    this.data.shouldSave = true;

    this.data.startMonth = val;

    this.props.onChange && this.props.onChange();

    if (this.state.startMonthError) {

      this.setState({
        startMonthError: '',
      });
    }
  };

  onEndMonthChange = val => {

    this.data.shouldSave = true;

    this.data.endMonth = val;

    this.props.onChange && this.props.onChange();

    if (this.state.endMonthError) {

      this.setState({
        endMonthError: '',
      });
    }
  };

  onDescriptionChange = val => {

    this.data.shouldSave = true;

    this.data.description = val;

    this.props.onChange && this.props.onChange();

    if (this.state.descriptionError) {

      this.setState({
        descriptionError: '',
      });
    }
  };

  onDeleteYesClick = () => {

    this.setState({
      showDeletePopup: false
    });

    typeof this.props.onDeleteClick === 'function' && this.props.onDeleteClick(this.data);
  };

  saveChanges = async () => {

    document.getElementById('experience-popup-content').scrollIntoView();

    this.setState({
      isLoading: true,
    });

    let ret;

    if (!this.data.id) {

      ret = await UserProvider.addExperience(
        this.props.userId,
        this.data.role,
        this.data.company,
        this.data.employmentType.value,
        this.data.startYear.value,
        this.data.startMonth.value,
        !this.state.isCurrentlyWorkingInThisRole ? this.data.endYear.value : undefined,
        !this.state.isCurrentlyWorkingInThisRole ? this.data.endMonth.value : undefined,
        this.data.description,
      );
    }

    if (this.data.id) {

      ret = await UserProvider.updateExperience(
        this.props.userId,
        this.data.id,
        this.data.role,
        this.data.company,
        this.data.employmentType.value,
        this.data.startYear.value,
        this.data.startMonth.value,
        !this.state.isCurrentlyWorkingInThisRole ? this.data.endYear.value : undefined,
        !this.state.isCurrentlyWorkingInThisRole ? this.data.endMonth.value : undefined,
        this.data.description,
      );
    }

    if (!isValidProviderResult(ret)) {

      ErrorToast.show();

      Logger.error(ret.message || Messages.TechnicalError);

      this.setState({
        isLoading: false,
      });

      return;
    }

    this.data.isCurrentlyWorkingInThisRole = this.state.isCurrentlyWorkingInThisRole;

    this.data.id = ret.data.id;

    typeof this.props.onSaveClick === 'function' && this.props.onSaveClick(this.data);

    typeof this.props.onClose === 'function' && this.props.onClose();
  };

  validate = () => {

    let errors = {};

    if (!this.data.role) {
      errors.roleError = 'Please enter your role';
    }

    if (!this.data.company) {
      errors.companyError = 'Please enter your company';
    }

    if (!this.data.employmentType || !this.data.employmentType.value) {
      errors.employmentTypeError = 'Please select an employment type';
    }

    if (!this.data.startYear || !this.data.startYear.value) {
      errors.startYearError = 'Please select the start year';
    }

    if (!this.data.startMonth || !this.data.startMonth.value) {
      errors.startMonthError = 'Please select a start month';
    }

    if (!this.state.isCurrentlyWorkingInThisRole && (!this.data.endYear || !this.data.endYear.value)) {
      errors.endYearError = 'Please select an end year';
    }

    if (!this.state.isCurrentlyWorkingInThisRole && (!this.data.endMonth || !this.data.endMonth.value)) {
      errors.endMonthError = 'Please select an end month';
    }

    if (!this.data.description) {
      errors.descriptionError = 'Please enter a description';
    }

    if (Object.keys(errors).length) {

      this.setState({
        roleError: '',
        companyError: '',
        employmentTypeError: '',
        startMonthError: '',
        endMonthError: '',
        startYearError: '',
        endYearError: '',
        descriptionError: '',
        ...errors,
      });
    }

    return errors;
  };

  load = async () => {

    const yearList = generateYearArray(null, null, true);

    const monthList = await LookupProvider.getMonths();
    const employmentTypes = await LookupProvider.getEmploymentTypes() || [];

    this.data.validate = this.validate;

    this.setState({
      employmentTypes,
      yearList,
      monthList,
    });
  };

  componentDidMount() {
    this.load();
  }

  render () {

    return (
      
      <React.Fragment>

        <PopupContent
          scroll={!this.state.isLoading}>

          { this.state.isLoading &&

            <LoadingContainer>

              <Loader
                size={50}
              />

            </LoadingContainer>
          }

          <Container
            id={'experience-popup-content'}>

            <ItemRow>

              <Item>

                <TextInput
                  id={'txt-account-add-experience-role'}
                  width={'100%'}
                  defaultValue={this.data.role}
                  label={'Position'}
                  onChange={this.onRoleChange}
                  hasError={!!this.state.roleError}
                  errorMessage={this.state.roleError}
                />

              </Item>

              <Item>

                <TextInput
                  id={'txt-account-add-experience-company'}
                  width={'100%'}
                  defaultValue={this.data.company}
                  label={'Company'}
                  onChange={this.onCompanyChange}
                  hasError={!!this.state.companyError}
                  errorMessage={this.state.companyError}
                />

              </Item>

              <Item>

                <Select
                  id={'select-account-add-experience-employment-type'}
                  width={'100%'}
                  defaultValue={this.data.employmentType && this.data.employmentType.value}
                  options={this.state.employmentTypes}
                  label={'Work type'}
                  onChange={this.onEmploymentTypeChange}
                  hasError={!!this.state.employmentTypeError}
                  errorMessage={this.state.employmentTypeError}
                />

              </Item>

            </ItemRow>

            <ItemRow>

              <Item>

                <Checkbox
                  isDefaultChecked={this.state.isCurrentlyWorkingInThisRole}
                  label={'I am currently working in this role'}
                  onClick={this.onIsCurrentlyWorkingInThisRoleClick}
                />

              </Item>

            </ItemRow>

            <ItemRow>

              <Item>

                <Select
                  id={'select-account-add-experience-start-year'}
                  width={'100%'}
                  defaultValue={this.data.startYear && this.data.startYear.value && this.data.startYear.value.toString()}
                  label={'Start year'}
                  options={this.state.yearList}
                  onChange={this.onStartYearChange}
                  hasError={!!this.state.startYearError}
                  errorMessage={this.state.startYearError}
                />

              </Item>

              <Item>

                <Select
                  id={'select-account-add-experience-start-month'}
                  width={'100%'}
                  defaultValue={this.data.startMonth && this.data.startMonth.value}
                  label={'Start month'}
                  onChange={this.onStartMonthChange}
                  options={this.state.monthList}
                  hasError={!!this.state.startMonthError}
                  errorMessage={this.state.startMonthError}
                />

              </Item>

              { !this.state.isCurrentlyWorkingInThisRole &&

                <React.Fragment>

                  <Item>

                    <Select
                      id={'select-account-add-experience-end-year'}
                      width={'100%'}
                      defaultValue={this.data.endYear && this.data.endYear.value && this.data.endYear.value.toString()}
                      label={'End year'}
                      options={this.state.yearList}
                      onChange={this.onEndYearChange}
                      hasError={!!this.state.endYearError}
                      errorMessage={this.state.endYearError}
                    />

                  </Item>

                  <Item>

                    <Select
                      id={'select-account-add-experience-end-month'}
                      width={'100%'}
                      defaultValue={this.data.endMonth && this.data.endMonth.value}
                      label={'End month'}
                      options={this.state.monthList}
                      onChange={this.onEndMonthChange}
                      hasError={!!this.state.endMonthError}
                      errorMessage={this.state.endMonthError}
                    />

                  </Item>

                </React.Fragment>
              }

            </ItemRow>

            <ItemRow>
              
              <Item>

                <TextInput
                  id={'txt-account-add-experience-description'}
                  width={'100%'}
                  defaultValue={this.data.description}
                  multiline={true}
                  label={'Further information'}
                  onChange={this.onDescriptionChange}
                  hasError={!!this.state.descriptionError}
                  errorMessage={this.state.descriptionError}
                  margin={'0'}
                  showCharCounter={true}
                  charCounterMax={2500}
                  charCounterColor={Colors.Red3}
                />

              </Item>

            </ItemRow>

          </Container>

          { this.props.onDeleteClick && 
            
            <DeleteContainer
              onClick={() => this.setState({ showDeletePopup: true })}
            />
          }

        </PopupContent>

        { !this.props.hideFooter &&

          <PopupFooter
            footerBackgroundColor={Colors.Red3}>

            <ActionContainer>

              <ActionButtonContainer>

                <Button
                  width={'100%'}
                  text={'CANCEL'}
                  onClick={() => { this.props.onClose && this.props.onClose(); }}
                />

              </ActionButtonContainer>

              &nbsp;&nbsp;

              <ActionButtonContainer>

                <Button
                  width={'100%'}
                  text={'SAVE CHANGES'}
                  onClick={this.onSaveChangesClick}
                />

              </ActionButtonContainer>

            </ActionContainer>

          </PopupFooter>
        }

        { this.state.showDeletePopup &&
        
          <Popup
            maxWidth={'500px'}
            header={'Confirm delete'}
            headerBackgroundColor={Colors.Red3}
            onClose={() => this.setState({ showDeletePopup: false })}>

            <Text
              fontSize={FontSizes.Normal}
              padding={'30px 30px 15px 30px'}>

                Are you sure you want to delete this entry?
            </Text>

            <Text
              color={Colors.Red2}
              fontSize={FontSizes.Small}
              padding={'0 30px 110px 30px'}
              flex={'1'}>

                Please note that this action cannot be undone.
            </Text>

            <PopupFooter
              footerBackgroundColor={Colors.Red3}>

              <PopupActionContainer>

                <PopupActionButtonContainer>

                  <Button
                    width={'100%'}
                    text={'NO'}
                    onClick={() => this.setState({ showDeletePopup: false })}
                  />
                
                </PopupActionButtonContainer>

                &nbsp;&nbsp;

                <PopupActionButtonContainer>

                  <Button
                    width={'100%'}
                    text={'YES'}
                    onClick={this.onDeleteYesClick}
                  />

                </PopupActionButtonContainer>

              </PopupActionContainer>

            </PopupFooter>

          </Popup>
        }

      </React.Fragment>
    );
  }
}